import { EtlHealthStatusPillV2 } from './etl-health-status-pill-v2';

type Props = {
  status: string;
};

function normalisePlatformHealthStatus(status: string): string {
  const value = status.toLowerCase();
  if (value === 'healthy') {
    return 'pass';
  }
  if (value === 'review') {
    return 'warning';
  }
  if (value === 'investigate') {
    return 'fail';
  }
  return status;
}

export function VerificationStatusBadge({ status }: Props) {
  return <EtlHealthStatusPillV2 status={normalisePlatformHealthStatus(status)} />;
}
